import type { ExecutionIntent } from '../MarketsTabV3/executionModel';
import type { FinancialInstrument, UnderlyingAsset } from 'state';
import { isSimplifiedOptionSettlementFailed } from '../../../state/app/simplified_options/presentation';
import { ordinaryQuoteIsAvailable } from '../MarketsTabV3/model';

export type MarketsExperience = 'classic' | 'board' | 'desk' | 'stack';

export const readMarketsExperience = (
  whichMarkets?: number | null,
): MarketsExperience => {
  if (whichMarkets === 1) return 'board';
  if (whichMarkets === 2) return 'desk';
  if (whichMarkets === 3) return 'stack';
  return 'classic';
};

export const refreshOpenOrder = (intent: ExecutionIntent): ExecutionIntent =>
  intent.kind === 'order' || intent.kind === 'optionOrder'
    ? { ...intent, activation: intent.activation + 1 }
    : intent;

export const shouldDisplayMarketInstrument = (
  instrument: FinancialInstrument,
  asset: UnderlyingAsset,
) => {
  const option = instrument.simplified_option;
  return option
    ? option.availability?.available === true ||
        isSimplifiedOptionSettlementFailed(option)
    : ordinaryQuoteIsAvailable(asset);
};

/**
 * Markets V5 display-only filtering. The source array and every player
 * instrument remain intact for positions, valuation, orders, and other views.
 */
export const filterMarketsV5HiddenInstruments = (
  instruments: FinancialInstrument[],
  hiddenUnderlyingAssetIds: number[],
) => {
  if (!hiddenUnderlyingAssetIds.length) return instruments;
  const hiddenIds = new Set(hiddenUnderlyingAssetIds);
  return instruments.filter(
    instrument => !hiddenIds.has(instrument.underlying_asset),
  );
};
